module.exports = __webpack_public_path__ + "img/home_PWstudio.b1dbdf28.jpg";